import { LitElement, html } from 'lit';
import { DebugService } from '../services/debug.service.js';
import { style } from './loading-spinner.style.js';

class RefiLoadingSpinner extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('LoadingSpinner');
    this.message = '';
  }

  static get properties() {
    return {
      message: { type: String, attribute: true },
    };
  }

  static get styles() {
    return style;
  }

  render() {
    this.debug.log('rendered');
    return html` <div class="grv-spinner">${this.message ? html` <span aria-label="${this.message}" role="alert">${this.message}</span> ` : ''}</div> `;
  }
}

customElements.define('refi-loading-spinner', RefiLoadingSpinner);
